export const ProfileStatus = {
  notLogin: "notLogin",
  incomplete: "incomplete",
  completed: "completed",
};
